import { END_POINTS } from "../constants/urls";
import { User } from "../types/User";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
  statusCode: number;
  data?: User;
  message: string;
}

interface CommonResponse {
  statusCode: number;
  message?: string;
  data?: any;
}

export const TransactionsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getTransactionList: builder.query<
      CommonResponse & { data: any },
      {
        page: number;
        limit: number;
        search: string;
        dateFrom: string;
        dateTo: string;
      }
    >({
      query: ({ page, limit, search, dateFrom, dateTo }) => {
        if (!dateFrom || !dateTo) {
          return {
            url: `${END_POINTS.transactions}?page=${page}&limit=${limit}&search=${search}`,
            method: "GET",
          };
        }
        return {
          url: `${END_POINTS.transactions}?page=${page}&limit=${limit}&search=${search}&dateFrom=${dateFrom}&dateTo=${dateTo}`,
          method: "GET",
        };
      },
      providesTags: ["TRANSACTIONS"],
    }),
    updateTransactions: builder.mutation<
      CommonResponseType & { data: any },
      { body: any; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.transactions}/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["TRANSACTIONS"],
    }),
  }),
});
export const { useLazyGetTransactionListQuery, useUpdateTransactionsMutation } =
  TransactionsApi;
